import { Component, ReactNode } from 'react'

import moment from 'moment'

import AddressInput from '../../address/Address'

import Input from '../../../libs/ui/inputs/Input'
import Select from '../../../libs/ui/inputs/Select'
import AutoCompleteInput from '../../../libs/ui/inputs/AutoCompleteInput'

import ButtonGorup from '../../../libs/ui/buttons/ButtonGroup'
import RadioButton from '../../../libs/ui/buttons/RadioButton'

import { DATE_FORMAT, DATE_PRINT_FORMAT, isNotValiDataNascita } from '../../../libs/validation/dateValidation'

import * as Validation from '../contractor/ContractorRemoteValidation'

import { COMUNI_SEARCH_URL } from '../../../costants'

import {
    NAMES_PATTERN, EMAIL_PATTERN, PHONE_NUMBER_PATTERN,
} from '../../../libs/validation/stringRegex'

export interface PersonFormProps {
    nome: string | undefined
    cognome: string | undefined
    sesso?: number | undefined
    dataNascita?: string | undefined
    natoInItalia?: boolean | undefined
    comune_nascita?: string | undefined
    stato_nascita?: number | undefined

    hideEmail?: boolean | undefined
    email: string | undefined

    hideCellulare?: boolean | undefined
    cellulare: string | undefined

    hideProfessione?: boolean | undefined
    professione?: string | undefined

    indirizzoResidenza?: string | undefined
    street?: string | undefined
    street_number?: string | undefined
    zip?: string | undefined
    city?: string | undefined
        
    updateName: Function
    updateCognome: Function
    updateEmail: Function
    updateCellulare: Function
    updateSesso?: Function
    updateDataNascita?: Function
    updateNatoInItalia?: Function
    updateComuneNascita?: Function
    updateStatoNascita?: Function

    updateProfessione?: Function

    updateIndirizzo?: Function
    updateStreet?: Function
    updateStreet_number?: Function
    updateZip?: Function
    updateCity?: Function
    updateAllAddressParts?: Function

    is_manual_address?: boolean
    updateManualSelectionCallBack?: Function    // salva la scelta tra inserimento manuale o autocompletamento del utente

    nomeError?: string | undefined
    cognomeError?: string | undefined
    emailError?: string | undefined
    phoneError?: string | undefined
    sessoError?: string | undefined
    dataNascitaError?: string | undefined
    natoInItaliaError?: string | undefined
    comuneError?: string | undefined
    statoError?: string | undefined
    profeError?: string | undefined

    indirizzoResidenzaError?: string | undefined
    streetError?: string | undefined
    street_numberError?: string | undefined
    zipError?: string | undefined
    cityError?: string | undefined

    clearNomeError?: Function
    clearCognomeError?: Function
    clearEmailError?: Function
    clearPhoneError?: Function
    clearSessoError?: Function
    clearDataNascitaError?: Function
    clearNatoInItaliaError?: Function
    clearComuneError?: Function
    clearStatoError?: Function
    clearProfeError?: Function

    clearIndirizzoResidenzaError?: Function
    clearStreetError?: Function
    clearStreet_numberError?: Function
    clearZipError?: Function
    clearCityError?: Function

    profList?: any | undefined
    statiList?: any | undefined

    isInsert?: boolean | undefined

    expiredSessionCallbak?: Function
}

interface State {
    is_manual_address: boolean
}

class PersonForm extends Component<PersonFormProps, State> {

    constructor (props: any) {
        super(props)

        this.state = {
            is_manual_address: (this.props.is_manual_address !== undefined) ? this.props.is_manual_address : false
        }

        this.updateAll = this.updateAll.bind(this)
        this.updateStreet = this.updateStreet.bind(this)
        this.updateNumber = this.updateNumber.bind(this)
        this.updateZip = this.updateZip.bind(this)
        this.updateCity = this.updateCity.bind(this)

        this.clearNomeError = this.clearNomeError.bind(this)
        this.clearCognomeError = this.clearCognomeError.bind(this)
        this.clearEmailError = this.clearEmailError.bind(this)
        this.clearPhoneError = this.clearPhoneError.bind(this)
        this.clearProfeError = this.clearProfeError.bind(this)
        this.clearSessoError = this.clearSessoError.bind(this)
        this.clearDataNascitaError = this.clearDataNascitaError.bind(this)
        this.clearNatoInItaliaError = this.clearNatoInItaliaError.bind(this)
        this.clearComuneError = this.clearComuneError.bind(this)
        this.clearStatoError = this.clearStatoError.bind(this)
        this.clearIndirizzoError = this.clearIndirizzoError.bind(this)

        this.setNatoInItalia = this.setNatoInItalia.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<PersonFormProps>, prevState: Readonly<State>, snapshot?: any): void {
        if (
            this.props.is_manual_address !== undefined &&
            this.props.is_manual_address !== prevProps.is_manual_address &&
            this.props.is_manual_address !== this.state.is_manual_address &&
            this.props.is_manual_address !== prevState.is_manual_address
        ) {
            this.setState({
                is_manual_address: this.props.is_manual_address
            })
        }
    }

    render(): ReactNode {
        const recivedActiveSesso = (this.props.sesso !== undefined) 
            ? ((Number(this.props.sesso) === 0) ? 'sesso_uomo' : 'sesso_donna')
            : undefined 
        const recivedBornInItaly = (this.props.natoInItalia !== undefined)
            ? (this.props.natoInItalia) ? 'nato_in_italia' : 'nato_al_estero'
            : undefined

        const statiPossibili = this.props.statiList?.filter( (s: any) => s?.id !== "13")

        const emailPhoneClassName = (this.props.hideEmail === true || this.props.hideCellulare === true)
            ? "col-12"
            : "col-md-6 col-12"

        const DATE_START = moment().subtract(100, 'year').subtract(1, 'day').format(DATE_FORMAT)
        const DATE_END = moment().subtract(18, 'year').subtract(1, 'day').format(DATE_FORMAT)
        const DATE_START_FORMATTED = moment().subtract(100, 'year').subtract(1, 'day').format(DATE_PRINT_FORMAT)
        const DATE_END_FORMATTED = moment().subtract(18, 'year').subtract(1, 'day').format(DATE_PRINT_FORMAT)

        return ( (this.props.profList !== undefined || this.props.hideProfessione === true) && 
                    this.props.statiList !== undefined &&
            <>
                { this.props.isInsert === true && 
                    <div className='row'>
                        <div className='col-md-6 col-12'>
                            <Input 
                                id='nome' name='nome' 
                                label='Nome' 
                                value={this.props.nome}
                                type='text'
                                maxLength={40}
                                callback={this.props.updateName}
                                regexp={NAMES_PATTERN}
                                errorDisplayMsg='Nome non valido'
                                remoteValidation={Validation.namesValidation}
                                error={this.props.nomeError}
                                onFocus={this.clearNomeError}
                            />
                        </div>
                        <div className='col-md-6 col-12'>
                            <Input 
                                id='cognome' name='cognome' 
                                label='Cognome' 
                                value={this.props.cognome}
                                type='text'
                                maxLength={40}
                                callback={this.props.updateCognome}
                                regexp={NAMES_PATTERN}
                                errorDisplayMsg='Cognome non valido'
                                remoteValidation={Validation.namesValidation}
                                error={this.props.cognomeError}
                                onFocus={this.clearCognomeError}
                            />
                        </div>
                    </div>
                }
                
                <div className='row'>
                    <div className='col-12'>
                        <ButtonGorup 
                            id='sesso'
                            label='Sesso'
                            value={this.props.sesso?.toString()}
                            callback={this.props.updateSesso}
                            error={this.props.sessoError}
                        >
                            <RadioButton 
                                id='sesso_uomo' name="sessoPersona" 
                                label="Uomo" 
                                value="0" 
                                activeId={ recivedActiveSesso }
                            />
                            <RadioButton 
                                id='sesso_donna' name="sessoPersona" 
                                label="Donna" 
                                value="1" 
                                activeId={ recivedActiveSesso }
                            />
                        </ButtonGorup>
                    </div>

                    <div className='col-12'>
                        <Input 
                            id='data_nascita' name='data_nascita'
                            label='Data di nascita'
                            type='date'
                            value={this.props.dataNascita}
                            min={DATE_START}
                            max={DATE_END}
                            callback={this.props.updateDataNascita}
                            errorDisplayMsg={
                                'tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED
                            }
                            regexp={this.isValidDate}
                            error={this.props.dataNascitaError}
                            onFocus={this.clearDataNascitaError}
                            ingoreLostFocus={true}
                        />
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <ButtonGorup 
                            id='nazionalitaItalina'
                            label='Paese di nascita'
                            value={ recivedBornInItaly }
                            callback={this.setNatoInItalia}
                            error={this.props.natoInItaliaError}
                        >
                            <RadioButton 
                                id='nato_in_italia' name="nazionalitaItalina" 
                                label="Italia" 
                                value="true" 
                                activeId={ recivedBornInItaly }
                            />
                            <RadioButton 
                                id='nato_al_estero' name="nazionalitaItalina" 
                                label="Altro" 
                                value="false" 
                                activeId={ recivedBornInItaly }
                            />
                        </ButtonGorup>
                    </div>

                    {this.props.natoInItalia === true &&
                        <AutoCompleteInput 
                            id='comune_nascita'
                            value={this.props.comune_nascita}
                            choices={[]}
                            label='Comune di nascita'
                            callback={this.props.updateComuneNascita}
                            updateChoicesUrl={COMUNI_SEARCH_URL}
                            error={this.props.comuneError}
                            getRequstBody={this.getComuneNascitaRequestBody}
                            expiredSessionCallbak={this.props.expiredSessionCallbak}
                            onFocus={this.clearComuneError}
                        />
                    }

                    {this.props.natoInItalia === false &&
                        <AutoCompleteInput 
                            id='stato_estero_di_nascita'
                            value={
                                (Number(this.props.stato_nascita) === 13)
                                    ? undefined
                                    : this.props.stato_nascita?.toString()
                            }
                            choices={statiPossibili}
                            label='Stato di nascita'
                            error={this.props.statoError}
                            callback={this.props.updateStatoNascita}
                            onFocus={this.clearStatoError}
                        />
                    }
                </div>

                <div className='row'>
                    <AddressInput 
                        value={this.props.indirizzoResidenza}

                        street={this.props.street}
                        number={this.props.street_number}
                        zip={this.props.zip}
                        city={this.props.city}

                        error={this.props.indirizzoResidenzaError}
                        streetError={this.props.streetError}
                        numberError={this.props.street_numberError}
                        zipError={this.props.zipError}
                        cityError={this.props.cityError}
                        
                        updateAll={this.updateAll}
                        updateStreet={this.updateStreet}
                        updateNumber={this.updateNumber}
                        updateZip={this.updateZip}
                        updateCity={this.updateCity}

                        is_manual_address={this.state.is_manual_address}
                        updateManualSelectionCallBack={this.props.updateManualSelectionCallBack}
                        
                        clearError={this.clearIndirizzoError}
                        clearStreetError={this.props.clearStreetError}
                        clearNumberError={this.props.clearStreet_numberError}
                        clearZipError={this.props.clearZipError}
                        clearCityError={this.props.clearCityError}

                        expiredSessionCallbak={this.props.expiredSessionCallbak}
                    />

                    {this.props.hideEmail !== true && 
                        <div className={emailPhoneClassName}>
                            <Input 
                                id='email' name='email' 
                                label='Email' 
                                value={this.props.email}
                                type='email'
                                maxLength={200}
                                callback={this.props.updateEmail}
                                regexp={EMAIL_PATTERN}
                                errorDisplayMsg='Email non valida'
                                remoteValidation={Validation.emailsValidation}
                                error={this.props.emailError}
                                onFocus={this.clearEmailError}
                            />
                        </div>
                    }

                    {this.props.hideCellulare !== true &&
                        <div className={emailPhoneClassName}>
                            <Input 
                                id='cellulare' label='Cellulare' name='cellulare' 
                                value={this.props.cellulare}
                                type='text'
                                maxLength={10}
                                callback={this.props.updateCellulare}
                                regexp={PHONE_NUMBER_PATTERN}
                                errorDisplayMsg='Telefono non valido'
                                remoteValidation={Validation.phonesValidation}
                                error={this.props.phoneError}
                                onFocus={this.clearPhoneError}
                            />
                        </div>
                    }

                </div>
                
                { this.props.hideProfessione !== true &&
                  this.props.profList !== undefined && (this.props.profList as Array<any>).length > 0 &&
                    <div className='row'>

                        <div className='col-12'>
                            <Select
                                id='professione' name='professione' key='area_professionale_p'
                                label='Professione' 
                                value={this.props.professione}
                                options={this.props.profList}
                                callback={this.props.updateProfessione}
                                error={this.props.profeError}
                                onFocus={this.clearProfeError}
                            />
                        </div>
                        
                    </div>
                }
            </>
        )
    }

    private updateAll (
        pStreet: string | undefined | null,
        pStreet_number: string | undefined | null,
        pZip: string | undefined | null,
        pCity: string | undefined | null
    ) {
        if (this.props.updateAllAddressParts) {
            this.props.updateAllAddressParts(
                pStreet,
                pStreet_number,
                pZip,
                pCity,
            )
        }
    }
    private updateStreet (val: string | undefined) {
        if (this.props.updateStreet) {
            this.props.updateStreet( val )
        }
    }
    private updateNumber (val: string | undefined) {
        if (this.props.updateStreet_number) {
            this.props.updateStreet_number( val )
        }
    }
    private updateZip (val: string | undefined) {
        if (this.props.updateZip) {
            this.props.updateZip( val )
        }
    }
    private updateCity (val: string | undefined) {
        if (this.props.updateCity) {
            this.props.updateCity( val )
        }
    }


    private clearNomeError () {
        if (this.props.clearNomeError) {
            this.props.clearNomeError()
        }
    }
    private clearCognomeError () {
        if (this.props.clearCognomeError) {
            this.props.clearCognomeError()
        }
    }
    private clearEmailError () {
        if (this.props.clearEmailError) {
            this.props.clearEmailError()
        }
    }
    private clearPhoneError () {
        if (this.props.clearPhoneError) {
            this.props.clearPhoneError()
        }
    }

    private clearSessoError () {
        if (this.props.clearSessoError) {
            this.props.clearSessoError()
        }
    }
    private clearDataNascitaError () {
        if (this.props.clearDataNascitaError) {
            this.props.clearDataNascitaError()
        }
    }
    private clearNatoInItaliaError () {
        if (this.props.clearNatoInItaliaError) {
            this.props.clearNatoInItaliaError()
        }
    }
    private clearComuneError () {
        if (this.props.clearComuneError) {
            this.props.clearComuneError()
        }
    }
    private clearStatoError () {
        if (this.props.clearStatoError) {
            this.props.clearStatoError()
        }
    }
    private clearProfeError () {
        if (this.props.clearProfeError) {
            this.props.clearProfeError()
        }
    }

    private clearIndirizzoError () {
        if (this.props.clearIndirizzoResidenzaError) {
            this.props.clearIndirizzoResidenzaError()
        }
    }

    private setNatoInItalia (val : string | undefined) {
        if (this.props.updateNatoInItalia) {
            this.props.updateNatoInItalia( val === 'true')

            if (this.props.updateStatoNascita) {
                this.props.updateStatoNascita( 
                    (val === 'true')
                        ? "13" 
                        : undefined
                )
            }
        }

        this.clearNatoInItaliaError()
    }

    private getComuneNascitaRequestBody (search: string | undefined) {
        return {
            nome: search,
            isResidenza: false
        }
    }

    private isValidDate (d: string | undefined) {
        if (d === undefined)
            return true

        return !isNotValiDataNascita( d )
    }

}

export default PersonForm